// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyBxVbJB0qFqR0OeyAeGfa_rv9N-odv7uBA",
    authDomain: "alagbeandpartners-b3e67.firebaseapp.com",
    projectId: "alagbeandpartners-b3e67",
    storageBucket: "alagbeandpartners-b3e67.appspot.com",
    messagingSenderId: "111585080536",
    appId: "1:111585080536:web:98a739e22c5df020f0d3ad",
    measurementId: "G-J3H4135HPE"
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
